module.exports = __webpack_public_path__ + "static/profile-97152b49f639293b7f08bf71cf22830f.png";